<div class="contact"
    [ngClass]="{'tooltip':isTooltip,'withGroups':numGroups!=undefined && numGroups>0 ,'inData':isData,'in-select':isSelect }">
    <div class="circle" [style.backgroundColor]="color">
        <p> {{ user?.firstName ? user?.firstName?.charAt(0)?.toUpperCase() : '' }}</p>
        <p>{{ user?.lastName ? user?.lastName?.charAt(0)?.toUpperCase() : '' }}</p>
    </div>
    <div>
        <div class="name ellipsis">
            <p class="ellipsis">{{user?.firstName}} {{user?.lastName}}</p>
            <p class="mainAnswer" *ngIf="mainAnswer"> - {{mainAnswer}}</p>
        </div>
        <div class="email ellipsis" *ngIf="!isTooltip">
            <p class="ellipsis">{{user?.email}}</p>
        </div>
    </div>
</div>
